$(document).ready(function(){

	$('.js-filter').click(function(){
		$('.filter-container').slideToggle();
	});


	$(window).bind("load", function(){

		$('.cf-select').selectric(); 

	});
  
	$(window).resize(function(){
		if ($(window).width() >= 992) {
			$('.filter-container').slideDown();
		} else {
			$('.filter-container').slideUp();
		}
	});

	// var returnUser = Cookies.get('visited');

	// if (!returnUser) {

		// Cookies.set('visited', true, { expires: 1 })
	
		// $('.js-newsletter-pop-up').each(function(){

		// 	$('.js-close-pop-up').click(function(){
		//       $('.js-newsletter-pop-up').removeClass('active');
		//     });

		//     setTimeout(function(){
		//       $('.js-newsletter-pop-up').addClass('active');
		//     }, 1000);

		// });

	// }

	

});